import { render, staticRenderFns } from "./VRole.vue?vue&type=template&id=99406d1e&"
import script from "./VRole.vue?vue&type=script&lang=js&"
export * from "./VRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports